import enhance from './enhancer';
import InfluencerSearchPage from './InfluencerSearchPage';

export default enhance(InfluencerSearchPage);
